export const qualityEN = {
  one: 'How would you rate this call?',
  two: 'How about your teacher?',
  success: 'Thanks for rating!',
  error: 'There was a problem qualifying the call'
}
